import { Model } from 'modules/core/lib/mobx-rest'

export interface IChange {
  [key: string]: any
}
class Change extends Model<IChange> {}

export default Change
